import { FC } from "react";
import toast from "react-hot-toast";
import Button from "../ui/Button";

// The full key, shown this once; only a hash is kept.
const IssuedKey: FC<{ value: string }> = ({ value }) => {
  const copy = () => {
    if (!navigator.clipboard) {
      toast.error("Kopjojeni çelësin me dorë");
      return;
    }
    navigator.clipboard.writeText(value)
      .then(() => toast.success("Çelësi u kopjua"))
      .catch(() => toast.error("Kopjojeni çelësin me dorë"));
  };
  return (
    <>
      <p className="text-sm font-semibold">Ruajeni çelësin tani. Nuk shfaqet më.</p>
      <div className="flex gap-2">
        <code className="min-w-0 flex-1 break-all rounded-lg bg-gray-100 px-3 py-2 text-xs">{value}</code>
        <Button btnType="custom" className="border border-primary text-primary" onClick={copy}>
          Kopjo
        </Button>
      </div>
    </>
  );
};

export default IssuedKey;
